import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IInitState {
  loading: boolean;
  data: any;
  error: string;
  successMsg: any;
  updateAppDetails: any;
}

const initialState = {
  loading: false,
  data: [],
  error: "",
  successMsg: {},
  updateAppDetails: {},
};

const forceUpdateSlice = createSlice({
  name: "forceUpdate",
  initialState,
  reducers: {
    forceUpdateRequest(state: IInitState,action: PayloadAction<any>) {
      state.loading = true;
      // state.filtersData = action.payload;
    },
    forceUpdateSuccess(state: IInitState, action: PayloadAction<any[]>) {
      state.loading = false;
      state.data = action.payload;
    },
    UpdateSingleAppDetails(state: IInitState, action: PayloadAction<any>) {
      state.loading = false;
      state.updateAppDetails = action.payload;
    },
  },
});

export const {
  forceUpdateRequest,
  forceUpdateSuccess,
  UpdateSingleAppDetails,
} = forceUpdateSlice.actions;
export default forceUpdateSlice.reducer;
